export function setDataOwner (state,payload) {
    state.dataOwner = payload
}